import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getCSRFToken = async () => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/csrf-token/`, {
      withCredentials: true, // Ensures cookies are sent with request
    });
    return response.data.csrfToken;
  } catch (error) {
    console.error("Error fetching CSRF token:", error);
    return null;
  }
};
